module.exports = __webpack_public_path__ + "img/joinUs_content3.7f536d69.png";